import React, { FC, useState } from 'react'
import { observer } from 'mobx-react'
import { Header } from '../../components/Header/Header'
import {
  ConsentCheckbox,
  ContentWrap,
  Footer,
  Page,
  RequiredLine,
  TermItemContainer,
} from './ConsentPage.styles'
import { Checkbox } from './Checkbox'

export const ConsentPage: FC = observer(() => {
  const [checked1, setChecked1] = useState(false)
  const [checked2, setChecked2] = useState(false)
  const [checked3, setChecked3] = useState(false)
  const [checked4, setChecked4] = useState(false)

  return (
    <Page>
      <Header />
      <ContentWrap>
        <h1>General conditions</h1>

        <h2>We value and protect your privacy</h2>

        <TermItemContainer>
          <h3>
            Terms and Conditions of use <span>*</span>
          </h3>
          <Checkbox checked={checked1} setChecked={setChecked1} />
          <p onClick={() => setChecked1(!checked1)}>
            I accept the terms and conditions of the video-identification
            process and the issuance of short term certificates
          </p>
          <a>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.9922 4.87507C15.9922 4.48616 16.3075 4.1709 16.6964 4.1709H21.0792C21.4934 4.1709 21.8292 4.50668 21.8292 4.9209L21.8292 9.36115C21.8292 9.75005 21.514 10.0653 21.1251 10.0653C20.7362 10.0653 20.4209 9.75005 20.4209 9.36115L20.4209 6.57507L14.0397 12.9563C13.7647 13.2313 13.3188 13.2313 13.0438 12.9563C12.7688 12.6813 12.7688 12.2355 13.0438 11.9605L19.425 5.57923H16.6964C16.3075 5.57923 15.9922 5.26397 15.9922 4.87507ZM4.1709 10.2917C4.1709 7.5096 6.42626 5.25423 9.2084 5.25423H12.4584C12.8473 5.25423 13.1626 5.5695 13.1626 5.9584C13.1626 6.3473 12.8473 6.66257 12.4584 6.66257H9.2084C7.20407 6.66257 5.57923 8.2874 5.57923 10.2917V16.7917C5.57923 18.7961 7.20407 20.4209 9.2084 20.4209H15.7084C17.7127 20.4209 19.3376 18.7961 19.3376 16.7917V13.5417C19.3376 13.1528 19.6528 12.8376 20.0417 12.8376C20.4306 12.8376 20.7459 13.1528 20.7459 13.5417V16.7917C20.7459 19.5739 18.4905 21.8292 15.7084 21.8292H9.2084C6.42626 21.8292 4.1709 19.5739 4.1709 16.7917V10.2917Z"
                fill="#5E3CB4"
              />
            </svg>
          </a>
        </TermItemContainer>

        <TermItemContainer>
          <h3>
            Privacy Policy <span>*</span>
          </h3>
          <Checkbox checked={checked2} setChecked={setChecked2} />
          <p onClick={() => setChecked2(!checked2)}>
            I have read the Privacy Policy and I consent to the processing and
            storage of my biometric data and the complete recording of the
            video. Otherwise, you have other alternatives identified in the
            Terms and Conditions
          </p>
          <a>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.9922 4.87507C15.9922 4.48616 16.3075 4.1709 16.6964 4.1709H21.0792C21.4934 4.1709 21.8292 4.50668 21.8292 4.9209L21.8292 9.36115C21.8292 9.75005 21.514 10.0653 21.1251 10.0653C20.7362 10.0653 20.4209 9.75005 20.4209 9.36115L20.4209 6.57507L14.0397 12.9563C13.7647 13.2313 13.3188 13.2313 13.0438 12.9563C12.7688 12.6813 12.7688 12.2355 13.0438 11.9605L19.425 5.57923H16.6964C16.3075 5.57923 15.9922 5.26397 15.9922 4.87507ZM4.1709 10.2917C4.1709 7.5096 6.42626 5.25423 9.2084 5.25423H12.4584C12.8473 5.25423 13.1626 5.5695 13.1626 5.9584C13.1626 6.3473 12.8473 6.66257 12.4584 6.66257H9.2084C7.20407 6.66257 5.57923 8.2874 5.57923 10.2917V16.7917C5.57923 18.7961 7.20407 20.4209 9.2084 20.4209H15.7084C17.7127 20.4209 19.3376 18.7961 19.3376 16.7917V13.5417C19.3376 13.1528 19.6528 12.8376 20.0417 12.8376C20.4306 12.8376 20.7459 13.1528 20.7459 13.5417V16.7917C20.7459 19.5739 18.4905 21.8292 15.7084 21.8292H9.2084C6.42626 21.8292 4.1709 19.5739 4.1709 16.7917V10.2917Z"
                fill="#5E3CB4"
              />
            </svg>
          </a>
        </TermItemContainer>

        <TermItemContainer>
          <h3>
            Open Banking Verification Policy <span>*</span>
          </h3>
          <Checkbox checked={checked3} setChecked={setChecked3} />
          <p onClick={() => setChecked3(!checked3)}>
            I consent to the use of my personal data to identifying myself with
            Signicat Open Banking Verification services.*
          </p>
          <a>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.9922 4.87507C15.9922 4.48616 16.3075 4.1709 16.6964 4.1709H21.0792C21.4934 4.1709 21.8292 4.50668 21.8292 4.9209L21.8292 9.36115C21.8292 9.75005 21.514 10.0653 21.1251 10.0653C20.7362 10.0653 20.4209 9.75005 20.4209 9.36115L20.4209 6.57507L14.0397 12.9563C13.7647 13.2313 13.3188 13.2313 13.0438 12.9563C12.7688 12.6813 12.7688 12.2355 13.0438 11.9605L19.425 5.57923H16.6964C16.3075 5.57923 15.9922 5.26397 15.9922 4.87507ZM4.1709 10.2917C4.1709 7.5096 6.42626 5.25423 9.2084 5.25423H12.4584C12.8473 5.25423 13.1626 5.5695 13.1626 5.9584C13.1626 6.3473 12.8473 6.66257 12.4584 6.66257H9.2084C7.20407 6.66257 5.57923 8.2874 5.57923 10.2917V16.7917C5.57923 18.7961 7.20407 20.4209 9.2084 20.4209H15.7084C17.7127 20.4209 19.3376 18.7961 19.3376 16.7917V13.5417C19.3376 13.1528 19.6528 12.8376 20.0417 12.8376C20.4306 12.8376 20.7459 13.1528 20.7459 13.5417V16.7917C20.7459 19.5739 18.4905 21.8292 15.7084 21.8292H9.2084C6.42626 21.8292 4.1709 19.5739 4.1709 16.7917V10.2917Z"
                fill="#5E3CB4"
              />
            </svg>
          </a>
        </TermItemContainer>

        <TermItemContainer>
          <h3>Biometric Consent</h3>
          <Checkbox checked={checked4} setChecked={setChecked4} />
          <p onClick={() => setChecked4(!checked4)}>
            I accept the terms and conditions of the video-identification
            process and the issuance of short term certificates
          </p>
          <a>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.9922 4.87507C15.9922 4.48616 16.3075 4.1709 16.6964 4.1709H21.0792C21.4934 4.1709 21.8292 4.50668 21.8292 4.9209L21.8292 9.36115C21.8292 9.75005 21.514 10.0653 21.1251 10.0653C20.7362 10.0653 20.4209 9.75005 20.4209 9.36115L20.4209 6.57507L14.0397 12.9563C13.7647 13.2313 13.3188 13.2313 13.0438 12.9563C12.7688 12.6813 12.7688 12.2355 13.0438 11.9605L19.425 5.57923H16.6964C16.3075 5.57923 15.9922 5.26397 15.9922 4.87507ZM4.1709 10.2917C4.1709 7.5096 6.42626 5.25423 9.2084 5.25423H12.4584C12.8473 5.25423 13.1626 5.5695 13.1626 5.9584C13.1626 6.3473 12.8473 6.66257 12.4584 6.66257H9.2084C7.20407 6.66257 5.57923 8.2874 5.57923 10.2917V16.7917C5.57923 18.7961 7.20407 20.4209 9.2084 20.4209H15.7084C17.7127 20.4209 19.3376 18.7961 19.3376 16.7917V13.5417C19.3376 13.1528 19.6528 12.8376 20.0417 12.8376C20.4306 12.8376 20.7459 13.1528 20.7459 13.5417V16.7917C20.7459 19.5739 18.4905 21.8292 15.7084 21.8292H9.2084C6.42626 21.8292 4.1709 19.5739 4.1709 16.7917V10.2917Z"
                fill="#5E3CB4"
              />
            </svg>
          </a>
        </TermItemContainer>
        <RequiredLine>* required</RequiredLine>
        <Footer $disabled={!checked1 || !checked2 || !checked3}>
          <a href="/form">
            I consent
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19.468 7.5489C19.7172 7.80731 19.7097 8.2188 19.4513 8.46799L10.1183 17.468C9.86651 17.7108 9.46773 17.7108 9.21593 17.468L4.54893 12.968C4.2905 12.7188 4.28301 12.3073 4.53218 12.0489C4.78136 11.7905 5.19285 11.783 5.45127 12.0322L9.66707 16.0971L18.5489 7.53221C18.8073 7.28302 19.2188 7.29049 19.468 7.5489Z"
                fill="white"
              />
            </svg>
          </a>
        </Footer>
      </ContentWrap>
    </Page>
  )
})
